export default __webpack_public_path__ + "static/media/img2.2b1dade7.jpg";